// src/components/Button.js
import React from 'react';

const Button = ({ children, onClick, className = '', ...props }) => {
  return (
    <button
      className={`font-medium bg-primary text-white border border-secondary p-2 rounded-full  ${className}`}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
